import { PrimaryClientType } from 'api/types/entity';
import { useTranslation } from 'libs/i18n';
import { Input } from 'libs/ui';
import { OrderSection } from 'modules/order/common/components';
import { Field } from 'modules/order/common/forms/orderForm';
import { ClientAutocompleteFeature } from 'modules/order/createOrder/features';

import { useClientSection } from './useClientSection';

export const ClientSection = () => {
  const { t } = useTranslation();

  const { clientTypeField, onChangeClient, onChangeClientType } =
    useClientSection();

  return (
    <OrderSection
      fields={[
        <Field.Autocomplete
          fullWidth
          showRequiredMark
          label={t('order.sections.clientSection.fields.clientType.label')}
          name="clientType"
          optionLabelKey="label"
          options={Object.values(PrimaryClientType).map((v) => ({
            label: t(`primaryClientType.${v}`),
            value: v,
          }))}
          optionValueKey="value"
          placeholder={t(
            'order.sections.clientSection.fields.clientType.placeholder'
          )}
          variant="select"
          onChange={onChangeClientType}
        />,
        !clientTypeField?.value?.value ? (
          <Input
            disabled
            showRequiredMark
            label={t('order.sections.clientSection.fields.client.label')}
            placeholder={t(
              'order.sections.clientSection.fields.client.placeholder'
            )}
          />
        ) : (
          <ClientAutocompleteFeature
            clientType={clientTypeField.value.value}
            onChange={onChangeClient}
          />
        ),
      ]}
      title={t('order.sections.clientSection.title')}
    />
  );
};
